import { render, staticRenderFns } from "./DocumentsMoveToModal.vue?vue&type=template&id=278c1e47&"
import script from "./DocumentsMoveToModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsMoveToModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports